import apiClient from './apiClient';

export interface MenuItem {
  code: string;
  label: string;
  route: string;
  desc: string;
}

export interface MenuResponse {
  items: MenuItem[];
  count: number;
}

export const pw98m2Api = {
  async getMenu(): Promise<MenuResponse> {
    const res = await apiClient.get('/api/pw98m2/menu');
    return res.data;
  },
};
